import React, { useState, useCallback, useEffect } from 'react'
import { useHistory } from 'react-router'

import { Modal, Form, Button, Row, Col, Alert, Card } from '@themesberg/react-bootstrap'
import { useCookies } from 'react-cookie'
import { createCartGroup } from '../../../controller/api/cartGroup'
import { Routes } from '../../../routes'

function defaultExpiredDate() {
  const date = new Date()
  date.setDate(date.getDate() + 14)
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${date.getFullYear()}-${month}-${day}`
}

function todayDateInput() {
  const date = new Date()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${date.getFullYear()}-${month}-${day}`
}

const GAME_OPTIONS = [
  { id: 'mega', label: 'Mega 6/45' },
  { id: 'power', label: 'Power 6/55' },
  { id: 'lotto535', label: 'LOTO 5/35' },
]

const PLAY_METHODS_BY_GAME = {
  lotto535: [
    { value: 'GROUP_NORMAL_4', label: 'Bao thường 4 số' },
    { value: 'GROUP_NORMAL_7', label: 'Bao thường 7 số' },
    { value: 'GROUP_NORMAL_8', label: 'Bao thường 8 số' },
    { value: 'GROUP_NORMAL_9', label: 'Bao thường 9 số' },
    { value: 'GROUP_NORMAL_10', label: 'Bao thường 10 số' },
    { value: 'GROUP_NORMAL_11', label: 'Bao thường 11 số' },
    { value: 'GROUP_NORMAL_12', label: 'Bao thường 12 số' },
    { value: 'GROUP_NORMAL_13', label: 'Bao thường 13 số' },
    { value: 'GROUP_NORMAL_14', label: 'Bao thường 14 số' },
    { value: 'GROUP_NORMAL_15', label: 'Bao thường 15 số' },
  ],
  mega: [
    { value: 'GROUP_5', label: 'Bao 5' },
    { value: 'GROUP_8', label: 'Bao 8' },
    { value: 'GROUP_9', label: 'Bao 9' },
    { value: 'GROUP_10', label: 'Bao 10' },
    { value: 'GROUP_11', label: 'Bao 11' },
    { value: 'GROUP_12', label: 'Bao 12' },
    { value: 'GROUP_13', label: 'Bao 13' },
    { value: 'GROUP_14', label: 'Bao 14' },
    { value: 'GROUP_15', label: 'Bao 15' },
    { value: 'GROUP_18', label: 'Bao 18' },
  ],
  power: [
    { value: 'GROUP_5', label: 'Bao 5' },
    { value: 'GROUP_8', label: 'Bao 8' },
    { value: 'GROUP_9', label: 'Bao 9' },
    { value: 'GROUP_10', label: 'Bao 10' },
    { value: 'GROUP_11', label: 'Bao 11' },
    { value: 'GROUP_12', label: 'Bao 12' },
    { value: 'GROUP_13', label: 'Bao 13' },
    { value: 'GROUP_14', label: 'Bao 14' },
    { value: 'GROUP_15', label: 'Bao 15' },
    { value: 'GROUP_18', label: 'Bao 18' },
  ],
}

export default function CartGroupCreate() {
  const history = useHistory()
  const [cookies] = useCookies(['lottmekong'])
  const [formData, setFormData] = useState({
    gameId: '',
    playMethod: '',
    numbers: '',
    isActive: true,
    expiredAt: defaultExpiredDate()
  })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [showPlayMethodModal, setShowPlayMethodModal] = useState(false)
  const [selectedNumbers, setSelectedNumbers] = useState([])
  const [selectedMainNumbers, setSelectedMainNumbers] = useState([])
  const [selectedSpecialNumbers, setSelectedSpecialNumbers] = useState([])
  const [showNumberPicker, setShowNumberPicker] = useState(false)

  const playMethods = formData.gameId ? (PLAY_METHODS_BY_GAME[formData.gameId] || []) : []

  useEffect(() => {
    if (!formData.gameId) {
      setFormData(prev => ({ ...prev, playMethod: '' }))
    }
    setSelectedNumbers([])
    setSelectedMainNumbers([])
    setSelectedSpecialNumbers([])
    setFormData(prev => ({ ...prev, numbers: '' }))
  }, [formData.gameId])

  useEffect(() => {
    setSelectedNumbers([])
    setSelectedMainNumbers([])
    setSelectedSpecialNumbers([])
    setFormData(prev => ({ ...prev, numbers: '' }))
  }, [formData.playMethod])

  useEffect(() => {
    if (!showNumberPicker || !formData.numbers) return
    const parts = formData.numbers.trim().split(/\s+/).filter(Boolean)
    if (formData.gameId === 'lotto535') {
      const required = getRequiredCount()
      if (required.main > 0 && required.special > 0 && parts.length >= required.main + required.special) {
        const mainParts = parts.slice(0, required.main).map((p) => parseInt(p, 10)).filter((n) => !Number.isNaN(n))
        const specialParts = parts.slice(required.main).map((p) => parseInt(p, 10)).filter((n) => !Number.isNaN(n))
        setSelectedMainNumbers(mainParts)
        setSelectedSpecialNumbers(specialParts)
      }
    } else {
      setSelectedNumbers(parts.map((p) => parseInt(p, 10)).filter((n) => !Number.isNaN(n)))
    }
  }, [showNumberPicker])

  const handleChange = useCallback((field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }))
    setError('')
  }, [])

  const getMaxNumber = () => {
    const ranges = { mega: 45, power: 55, lotto535: 35 }
    return ranges[formData.gameId] || 45
  }

  const getRequiredCount = () => {
    if (!formData.playMethod) return 0
    if (formData.gameId === 'lotto535') {
      if (formData.playMethod.startsWith('GROUP_NORMAL_')) {
        return { main: parseInt(formData.playMethod.split('GROUP_NORMAL_')[1]) || 0, special: 1 }
      }
      return { main: 5, special: 1 }
    }
    if (['mega', 'power'].includes(formData.gameId) && formData.playMethod.startsWith('GROUP_')) {
      return parseInt(formData.playMethod.split('GROUP_')[1]) || 0
    }
    return 0
  }

  const check10 = (n) => (n < 10 ? `0${n}` : n)

  const toggleNumber = (n) => {
    const index = selectedNumbers.indexOf(n)
    const required = getRequiredCount()
    if (index > -1) {
      setSelectedNumbers(prev => prev.filter(num => num !== n))
    } else {
      if (required > 0 && selectedNumbers.length >= required) return
      setSelectedNumbers(prev => [...prev, n])
    }
  }

  const toggleMainNumber = (n) => {
    const index = selectedMainNumbers.indexOf(n)
    const required = getRequiredCount()
    if (index > -1) {
      setSelectedMainNumbers(prev => prev.filter(num => num !== n))
    } else {
      if (required.main > 0 && selectedMainNumbers.length >= required.main) return
      setSelectedMainNumbers(prev => [...prev, n])
    }
  }

  const toggleSpecialNumber = (n) => {
    const index = selectedSpecialNumbers.indexOf(n)
    const required = getRequiredCount()
    if (index > -1) {
      setSelectedSpecialNumbers(prev => prev.filter(num => num !== n))
    } else {
      if (required.special > 0 && selectedSpecialNumbers.length >= required.special) return
      setSelectedSpecialNumbers(prev => [...prev, n])
    }
  }

  const confirmNumberSelection = () => {
    let numbersString = ''
    if (formData.gameId === 'lotto535') {
      const mainStr = selectedMainNumbers.sort((a, b) => a - b).map(n => check10(n)).join(' ')
      const specialStr = selectedSpecialNumbers.sort((a, b) => a - b).map(n => check10(n)).join(' ')
      numbersString = `${mainStr} ${specialStr}`.trim()
    } else {
      numbersString = selectedNumbers.sort((a, b) => a - b).map(n => check10(n)).join(' ')
    }
    setFormData(prev => ({ ...prev, numbers: numbersString }))
    setShowNumberPicker(false)
  }

  const clearNumberSelection = () => {
    setSelectedNumbers([])
    setSelectedMainNumbers([])
    setSelectedSpecialNumbers([])
    setFormData(prev => ({ ...prev, numbers: '' }))
  }

  const randomSelect = () => {
    if (formData.gameId === 'lotto535' && formData.playMethod) {
      const mainPool = Array.from({ length: 35 }, (_, i) => i + 1)
      const specialPool = Array.from({ length: 12 }, (_, i) => i + 1)
      const required = getRequiredCount()
      const shuffledMain = [...mainPool].sort(() => 0.5 - Math.random())
      const shuffledSpecial = [...specialPool].sort(() => 0.5 - Math.random())
      if (formData.playMethod.startsWith('GROUP_NORMAL_')) {
        setSelectedMainNumbers(shuffledMain.slice(0, required.main))
        setSelectedSpecialNumbers([shuffledSpecial[0]])
      } else {
        setSelectedMainNumbers(shuffledMain.slice(0, 5))
        setSelectedSpecialNumbers(shuffledSpecial.slice(0, required.special))
      }
    } else {
      const pool = Array.from({ length: getMaxNumber() }, (_, i) => i + 1)
      const shuffled = [...pool].sort(() => 0.5 - Math.random())
      const required = getRequiredCount()
      setSelectedNumbers(shuffled.slice(0, required))
    }
  }

  const selectedPlayMethodLabel = formData.playMethod
    ? (playMethods.find(m => m.value === formData.playMethod)?.label || formData.playMethod)
    : ''

  const isNumberSelectionValid = () => {
    if (!formData.playMethod) return false
    if (formData.gameId === 'lotto535') {
      const required = getRequiredCount()
      return selectedMainNumbers.length === required.main && selectedSpecialNumbers.length === required.special
    }
    const required = getRequiredCount()
    return required > 0 ? selectedNumbers.length === required : selectedNumbers.length > 0
  }

  const numbersArray = formData.numbers ? formData.numbers.trim().split(/\s+/).filter(Boolean) : []

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    if (!formData.gameId) {
      setError('Vui lòng chọn trò chơi')
      setLoading(false)
      return
    }
    if (!formData.playMethod) {
      setError('Vui lòng chọn cách chơi')
      setLoading(false)
      return
    }
    if (!formData.numbers.trim()) {
      setError('Vui lòng nhập dãy số')
      setLoading(false)
      return
    }
    if (!formData.expiredAt) {
      setError('Vui lòng chọn ngày hết hạn')
      setLoading(false)
      return
    }

    try {
      const response = await createCartGroup(cookies.lottmekong, {
        gameId: formData.gameId,
        playMethod: formData.playMethod,
        numbers: formData.numbers.trim(),
        percent: 100,
        isActive: formData.isActive,
        expiredAt: formData.expiredAt
      })

      if (response && response.error === 0) {
        setFormData({ gameId: '', playMethod: '', numbers: '', isActive: true, expiredAt: defaultExpiredDate() })
        history.push(formData.isActive ? Routes.VietlottGroupActive.path : Routes.VietlottGroupPending.path)
      } else {
        setError(response?.message || 'Có lỗi xảy ra khi tạo nhóm mua chung')
      }
    } catch (err) {
      console.error('Error creating cart group:', err)
      setError('Có lỗi xảy ra khi tạo nhóm mua chung')
    } finally {
      setLoading(false)
    }
  }, [formData, cookies.lottmekong, history])

  const handleCancel = () => {
    if (!loading) {
      history.push(Routes.VietlottGroupActive.path)
    }
  }

  return (
    <>
      <Card border="light" className="shadow-sm mb-4">
        <Card.Header>
          <h5 className="mb-0">Tạo nhóm mua chung mới</h5>
        </Card.Header>
        <Form onSubmit={handleSubmit}>
          <Card.Body>
            {error && (
              <Alert variant="danger" className="mb-3">
                {error}
              </Alert>
            )}

            <Row className="mb-3">
              <Col>
                <Form.Label className="mb-2">Trò chơi <span className="text-danger">*</span></Form.Label>
                <div className="d-flex gap-2 flex-wrap">
                  {GAME_OPTIONS.map((game) => (
                    <button
                      key={game.id}
                      type="button"
                      onClick={() => handleChange('gameId', formData.gameId === game.id ? '' : game.id)}
                      className={`flex-grow-1 flex-shrink-0 d-flex flex-column align-items-center justify-content-center p-3 rounded-3 border border-2 transition-all ${
                        formData.gameId === game.id
                          ? 'border-primary bg-primary bg-opacity-10 shadow'
                          : 'border-secondary bg-white'
                      }`}
                      style={{ minHeight: '88px' }}
                    >
                      <img
                        src={`/images/${game.id}_logo.png`}
                        alt={game.label}
                        style={{ width: 48, height: 48, objectFit: 'contain' }}
                        onError={(e) => { e.target.style.display = 'none' }}
                      />
                      <span className="small fw-semibold text-dark mt-1">{game.label}</span>
                    </button>
                  ))}
                </div>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Label className="mb-1">Cách chơi <span className="text-danger">*</span></Form.Label>
                <button
                  type="button"
                  onClick={() => setShowPlayMethodModal(true)}
                  disabled={!formData.gameId}
                  className={`w-100 px-3 py-2 rounded-3 border text-start d-flex align-items-center justify-content-between ${
                    formData.playMethod
                      ? 'border-primary bg-primary bg-opacity-10 text-dark'
                      : 'border-secondary text-muted'
                  }`}
                >
                  <span className={formData.playMethod ? 'fw-medium' : ''}>
                    {selectedPlayMethodLabel || 'Chọn cách chơi'}
                  </span>
                  <i className="material-icons text-secondary">expand_more</i>
                </button>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Label className="mb-1">Dãy số <span className="text-danger">*</span></Form.Label>
                <div className="d-flex gap-2 flex-wrap align-items-center">
                  {formData.numbers ? (
                    <div className="d-flex flex-wrap gap-1 align-items-center flex-grow-1 p-2 rounded-3 bg-light border">
                      {numbersArray.map((num, idx) => (
                        <span
                          key={`${num}-${idx}`}
                          className={`d-inline-flex align-items-center justify-content-center rounded-pill border px-2 small fw-semibold ${
                            formData.gameId === 'lotto535' && idx === numbersArray.length - 1
                              ? 'bg-warning bg-opacity-75 text-dark border-warning'
                              : 'bg-amber-100 text-amber-900 border-amber-200'
                          }`}
                          style={{ minWidth: 28, height: 28 }}
                        >
                          {num}
                        </span>
                      ))}
                    </div>
                  ) : (
                    <div className="flex-grow-1 p-2 rounded-3 border border-secondary border-dashed text-muted small">
                      {!formData.gameId || !formData.playMethod ? 'Chọn trò chơi và cách chơi trước' : 'Chưa chọn số'}
                    </div>
                  )}
                  <Button
                    variant="primary"
                    onClick={() => setShowNumberPicker(true)}
                    disabled={!formData.gameId || !formData.playMethod}
                    className="rounded-3"
                  >
                    Chọn số
                  </Button>
                  {formData.numbers && (
                    <Button variant="outline-danger" size="sm" onClick={clearNumberSelection} className="rounded-3">
                      Xóa
                    </Button>
                  )}
                </div>
                {formData.gameId === 'lotto535' && formData.playMethod && (
                  <Form.Text className="text-amber-700 d-block mt-1 small">
                    LOTO 5/35: chọn số chính (1–35) và <strong>1 số đặc biệt (1–12)</strong>
                  </Form.Text>
                )}
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Label className="mb-1">Ngày hết hạn <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="date"
                  min={todayDateInput()}
                  value={formData.expiredAt}
                  onChange={(e) => handleChange('expiredAt', e.target.value)}
                  required
                />
                <Form.Text className="text-muted">
                  Nhóm còn hiệu lực đến hết ngày đã chọn.
                </Form.Text>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Label className="mb-2">Trạng thái</Form.Label>
                <div className="d-flex gap-3">
                  <Form.Check
                    type="radio"
                    id="status-active"
                    name="isActive"
                    label="Hoạt động (cho phép góp ngay)"
                    checked={formData.isActive === true}
                    onChange={() => handleChange('isActive', true)}
                  />
                  <Form.Check
                    type="radio"
                    id="status-inactive"
                    name="isActive"
                    label="Không hoạt động (chờ kích hoạt sau)"
                    checked={formData.isActive === false}
                    onChange={() => handleChange('isActive', false)}
                  />
                </div>
              </Col>
            </Row>

            {showNumberPicker && (
              <Modal show onHide={() => setShowNumberPicker(false)} size="lg">
                <Modal.Header closeButton>
                  <Modal.Title>Chọn số</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                  {formData.gameId === 'lotto535' ? (
                    <>
                      <div className="mb-4">
                        <h6>
                          Số chính (1 - 35)
                          {getRequiredCount().main > 0 && (
                            <span className="text-primary ms-2">({selectedMainNumbers.length}/{getRequiredCount().main})</span>
                          )}
                        </h6>
                        <div className="d-flex flex-wrap gap-2">
                          {Array.from({ length: 35 }, (_, i) => i + 1).map((n) => {
                            const required = getRequiredCount()
                            const isSelected = selectedMainNumbers.includes(n)
                            const isDisabled = required.main > 0 && selectedMainNumbers.length >= required.main && !isSelected
                            return (
                              <span
                                key={`main-${n}`}
                                role="button"
                                tabIndex={0}
                                className={`d-inline-flex align-items-center justify-content-center rounded-circle border ${
                                  isSelected ? 'bg-primary text-white border-primary' : isDisabled ? 'bg-light text-muted opacity-50' : 'bg-light'
                                }`}
                                style={{ width: 40, height: 40, fontSize: 14 }}
                                onClick={() => !isDisabled && toggleMainNumber(n)}
                              >
                                {check10(n)}
                              </span>
                            )
                          })}
                        </div>
                      </div>
                      <div>
                        <h6>
                          Số đặc biệt (1 - 12)
                          {getRequiredCount().special > 0 && (
                            <span className="text-warning ms-2">({selectedSpecialNumbers.length}/{getRequiredCount().special})</span>
                          )}
                        </h6>
                        <div className="d-flex flex-wrap gap-2">
                          {Array.from({ length: 12 }, (_, i) => i + 1).map((n) => {
                            const required = getRequiredCount()
                            const isSelected = selectedSpecialNumbers.includes(n)
                            const isDisabled = required.special > 0 && selectedSpecialNumbers.length >= required.special && !isSelected
                            return (
                              <span
                                key={`special-${n}`}
                                role="button"
                                tabIndex={0}
                                className={`d-inline-flex align-items-center justify-content-center rounded-circle border ${
                                  isSelected ? 'bg-warning text-white border-warning' : isDisabled ? 'bg-light text-muted opacity-50' : 'bg-light'
                                }`}
                                style={{ width: 40, height: 40, fontSize: 14 }}
                                onClick={() => !isDisabled && toggleSpecialNumber(n)}
                              >
                                {check10(n)}
                              </span>
                            )
                          })}
                        </div>
                      </div>
                    </>
                  ) : (
                    <div>
                      {getRequiredCount() > 0 && (
                        <p className="mb-3">
                          Đã chọn: <strong>{selectedNumbers.length}</strong> / <strong>{getRequiredCount()}</strong> số
                        </p>
                      )}
                      <div className="d-flex flex-wrap gap-2">
                        {Array.from({ length: getMaxNumber() }, (_, i) => i + 1).map((n) => {
                          const required = getRequiredCount()
                          const isSelected = selectedNumbers.includes(n)
                          const isDisabled = required > 0 && selectedNumbers.length >= required && !isSelected
                          return (
                            <span
                              key={n}
                              role="button"
                              tabIndex={0}
                              className={`d-inline-flex align-items-center justify-content-center rounded-circle border ${
                                isSelected ? 'bg-primary text-white border-primary' : isDisabled ? 'bg-light text-muted opacity-50' : 'bg-light'
                              }`}
                              style={{ width: 40, height: 40, fontSize: 14 }}
                              onClick={() => !isDisabled && toggleNumber(n)}
                            >
                              {check10(n)}
                            </span>
                          )
                        })}
                      </div>
                    </div>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="outline-secondary" onClick={randomSelect} className="rounded-3">
                    Thần Tài Ban số
                  </Button>
                  <Button variant="secondary" onClick={() => setShowNumberPicker(false)} className="rounded-3">
                    Hủy
                  </Button>
                  <Button variant="primary" onClick={confirmNumberSelection} disabled={!isNumberSelectionValid()} className="rounded-3">
                    Xác nhận
                  </Button>
                </Modal.Footer>
              </Modal>
            )}

            {showPlayMethodModal && (
              <Modal show onHide={() => setShowPlayMethodModal(false)} size="lg" centered>
                <Modal.Header closeButton>
                  <Modal.Title>Chọn cách chơi</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {!formData.gameId ? (
                    <p className="text-muted text-center py-4">Chọn trò chơi trước</p>
                  ) : playMethods.length === 0 ? (
                    <p className="text-muted text-center py-4">Không có cách chơi cho trò chơi này</p>
                  ) : (
                    <div className="row g-2">
                      {playMethods.map((method) => (
                        <div key={method.value} className="col-6 col-md-4">
                          <button
                            type="button"
                            onClick={() => {
                              handleChange('playMethod', method.value)
                              setShowPlayMethodModal(false)
                            }}
                            className={`w-100 p-3 rounded-3 border-2 text-center ${
                              formData.playMethod === method.value
                                ? 'border-primary bg-primary bg-opacity-10 text-primary fw-semibold'
                                : 'border-secondary bg-white'
                            }`}
                          >
                            {method.label}
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </Modal.Body>
              </Modal>
            )}
          </Card.Body>
          <Card.Footer>
            <Button variant="secondary" onClick={handleCancel} disabled={loading} className="rounded-3 px-4">
              Hủy
            </Button>
            <Button variant="primary" type="submit" disabled={loading} className="rounded-3 px-4 ms-2">
              {loading ? 'Đang tạo...' : 'Tạo'}
            </Button>
          </Card.Footer>
        </Form>
      </Card>
    </>
  )
}
